/* Denoon London: keep the free UK delivery bar in the cart drawer up to date */
(function () {
  function format(pence) { return '£' + (pence / 100).toFixed(2); }
  function update() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.currency !== 'GBP') return;
        document.querySelectorAll('[data-denoon-fs-bar]').forEach(function (bar) {
          var threshold = parseInt(bar.dataset.threshold, 10);
          var remaining = threshold - cart.total_price;
          var pct = Math.min(100, Math.floor((cart.total_price * 100) / threshold));
          bar.classList.toggle('denoon-fs-bar--hidden', cart.item_count === 0);
          bar.querySelector('[data-denoon-fs-text]').textContent = remaining > 0
            ? "You're " + format(remaining) + ' away from free UK delivery'
            : "You've unlocked free UK delivery";
          bar.querySelector('[data-denoon-fs-fill]').style.width = pct + '%';
          var track = bar.querySelector('[role="progressbar"]');
          if (track) track.setAttribute('aria-valuenow', pct);
        });
      })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', function () {
    var target = document.getElementById('cart-notification-subtotal');
    if (target) new MutationObserver(update).observe(target, { childList: true, characterData: true, subtree: true });
  });
})();
